import { render, staticRenderFns } from "./GalleryMain.vue?vue&type=template&id=1563affc&scoped=true&lang=pug"
import script from "./GalleryMain.vue?vue&type=script&lang=ts"
export * from "./GalleryMain.vue?vue&type=script&lang=ts"
import style0 from "./GalleryMain.vue?vue&type=style&index=0&id=1563affc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563affc",
  null
  
)

export default component.exports